// extracted by mini-css-extract-plugin
export var infoItem = "_ox-2";
export var title = "_ox-0";
export var value = "_ox-1";